module.exports = __webpack_public_path__ + "static/img/c369ae3e62a821ac7d6a2839d780f511.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/产品与服务-改(1)_47.png
// module id = kIdS
// module chunks = 1